import { Box, Grid, Typography } from "@mui/material";
import data from "../../Assets/data/News.json";

const NewsContainer = () => {
  return (
    <>
      <>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "2em",
          }}
        >
          <Box
            style={{
              width: "100%",
              background:
                "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
            }}
          >
            <Typography
              style={{
                padding: "32px",
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
                boxSizing: "border-box",
                marginRight: "32px",
              }}
              fontSize="32px"
              fontWeight={600}
            >
              NEWS
            </Typography>
          </Box>
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              {data.map((news, i) => {
                return news.image ? (
                  <>
                    <Grid item xs={3}>
                      <Box
                        style={{
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          marginRight: "12px",
                        }}
                      >
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Images/News/" +
                            news.image
                          }
                          alt="news"
                          style={{ width: "-webkit-fill-available" }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={9} key={i}>
                      <Typography
                        fontWeight={600}
                        fontSize="24px"
                        margin="16px 0px 6px"
                      >
                        {news.title}
                      </Typography>
                      <Typography>{news.description}</Typography>
                      <Typography>{news.date}</Typography>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} key={i}>
                    <Typography
                      fontWeight={600}
                      fontSize="24px"
                      margin="16px 0px 6px"
                    >
                      {news.title}
                    </Typography>
                    <Typography>{news.description}</Typography>
                    <Typography>{news.date}</Typography>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </>
    </>
  );
};

export default NewsContainer;
